export default "__VITE_ASSET__BjcWfVpx__"